import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from './components/Dropdown';

const TopMenuMobile = ({ items, toggleMobileMenu }) => {
    return (
        <div className="flex bg-white dark:bg-gray-800 h-full items-center justify-center">
            <ul className="flex bg-gray-100 dark:bg-gray-800 w-full  flex-col font-medium mt-0 px-10 py-10 text-lg">
                {items.map((item, index) => (
                    <li key={index} className="py-1 border-b">
                        {!item?.dropdown ? (
                            <NavLink to={item.to} onClick={toggleMobileMenu} className={({ isActive }) => (isActive ? 'text-[#41A6D7]  flex items-center hover:underline' : 'text-gray-600 dark:text-gray-200 flex items-center hover:underline')}>
                                <FontAwesomeIcon icon={item.icon} className="mr-2" />
                                {item.label}
                            </NavLink>
                        ) : (
                            <NavLink to={item.to} onClick={toggleMobileMenu} className={({ isActive }) => (isActive ? 'text-[#41A6D7]  flex items-center hover:underline' : 'text-gray-600 dark:text-gray-200 flex items-center hover:underline')}>
                                <FontAwesomeIcon icon={item.icon} className="mr-2" />
                                {item.label}
                            </NavLink>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TopMenuMobile;
